
import { Component, Vue } from 'vue-property-decorator';
import Breadcrumb from '@/components/Breadcrumb/index.vue';

@Component({
  name: 'AppMainAgent',
  components: {
    Breadcrumb
  },
  computed: {

  }
})
export default class extends Vue {}
